/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Hidden, breakpoints } from '@coursera/cds-core';

import type { DegreesV1 } from 'bundles/degree-home/components/__generated__/DegreesV1';
import Curriculum from 'bundles/degree-home/components/v3-dpm/components/Curriculum';
import DegreeAuditDisclaimer from 'bundles/degree-home/components/v3-dpm/components/DegreeAuditDisclaimer';
import DegreeProgressCard from 'bundles/degree-home/components/v3-dpm/components/DegreeProgressCard';
import EstimatedGraduationCard from 'bundles/degree-home/components/v3-dpm/components/EstimatedGraduationDate/EstimatedGraduationCard';
import HelpTipsEntrypoint from 'bundles/degree-home/components/v3-dpm/components/HelpTips';
import DegreePlanningTool from 'bundles/degree-home/components/v3-dpm/components/PlanningTool';
import { PATHS } from 'bundles/degree-home/components/v3-dpm/constants/constants';
import DegreeMetadataContext from 'bundles/degree-home/components/v3-dpm/context/DegreeMetadataContext';
import PageContainer from 'bundles/degree-home/components/v3-dpm/pages/PageContainer';
import {
  Container,
  MainContentHalfWidth,
  SidebarHalfWidth,
} from 'bundles/degree-home/components/v3-dpm/pages/pageStyles';

type Props = {
  degreeMetadata: DegreesV1;
};

const styles = {
  container: css`
    width: 100%;
  `,
  innerContainer: css`
    ${breakpoints.down('sm')} {
      margin-bottom: 0;
    }
  `,
  mainContent: css`
    margin-bottom: var(--cds-spacing-400);
  `,
  sideContent: css`
    margin-bottom: var(--cds-spacing-400);
    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
};

const Academics: React.VFC<Props> = ({ degreeMetadata }) => {
  return (
    <DegreeMetadataContext degreeMetadata={degreeMetadata}>
      <PageContainer pathToRedirectToIfNotV3={PATHS.SUMMARY} tabPanelValue={PATHS.ACADEMICS}>
        <div css={styles.container}>
          <DegreeAuditDisclaimer />
          <DegreeProgressCard variant="detail" />
          <Hidden mdUp>
            <EstimatedGraduationCard variant="detail" />
          </Hidden>
          <Container css={styles.innerContainer}>
            <MainContentHalfWidth css={styles.mainContent}>
              <Curriculum />
            </MainContentHalfWidth>
            <SidebarHalfWidth css={styles.sideContent}>
              <DegreePlanningTool />
            </SidebarHalfWidth>
          </Container>
          <HelpTipsEntrypoint />
        </div>
      </PageContainer>
    </DegreeMetadataContext>
  );
};

export default Academics;
